import { useControlledSwr } from '@systemeio/util'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { EVENTS_API } from '../api/events-api'
import { MyEventInterface } from '../types/event-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export function useMyEvents(shouldFetch: boolean = true) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, MyEventInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: myEvents, mutate } = useControlledSwr(
    [`${EVENTS_API}/my-events`, RequestModuleEnum.Calendar],
    fetcher,
    undefined,
    shouldFetch && !!user,
  )

  return { myEvents, mutate }
}
